<template>
  <q-select
    :value="formattedValue"
    @change="val => $emit('input', val)"
    :options="values"
    :multiple="multiple"
    :disable="disable"
    />
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    picklistId: {
      required: true
    },
    multiple: Boolean,
    disable: Boolean
  },
  computed: {
    values () {
      return this.$store.getters.picklistValues(this.picklistId, this.$i18n.locale)
    },
    formattedValue () {
      if (this.multiple) {
        return this.value ? Array.from(this.value) : []
      } else {
        return this.value
      }
    }
  },
  created () {
    this.$store.dispatch('getPicklistValues', { id: this.picklistId, locale: this.$i18n.locale })
  }
}
</script>
